<style>
  /* copied from: https://stackoverflow.com/questions/39846282/how-to-add-the-text-on-and-off-to-toggle-button */
 .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.switch input {display:none;}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #adb5bd;
  background-color: #fff;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #adb5bd;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: rgb(180, 3, 3);
}

input:checked + .slider.round.disabled {
  background-color: grey;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

.on
{
  display: none;
}

.on, .off
{
  color: white;
  position: absolute;
  transform: translate(-50%,-50%);
  top: 50%;
  left: 50%;
  font-size: 10px;
  font-family: Verdana, sans-serif;
}

input:checked+ .slider .on
{display: block;}

input:checked+ .slider.round.disabled .on .fa
{ color: #fff; }

input:checked + .slider .off
{ display: none;}

input:checked + .slider.round:before
{ background-color: #fff;}

/* Rounded sliders */
.slider.round {
  border-radius: 18px;
}

.slider.round:before {
  border-radius: 50%;
}

.disabled {
  color: grey;
}
</style>

<script>
  import { createEventDispatcher} from "svelte";
  import ModalConfirm from "../components/modalconfirm.svelte";
  const dispatch = new createEventDispatcher();

  export let checked = false; 
  export let label="";
  export let icon = "";
  export let disabled = false;
  export let checkedModalHeader = "";
  export let uncheckedModalHeader = "";
  export let checkedModalMessage = "";
  export let uncheckedModalMessage = "";

  let showModal = false;

  console.log("checked")
  console.log(checked);
  
  const Switch = () => {
    showModal = false;
    dispatch("switch")
  };

  const Cancel = () => {
    checked = !checked;
  };

  const handleClick = () => {
    showModal = true;
  }

</script>

<span for="togBtn" class="{disabled ? 'disabled' : ''}" style="position: relative; display: inline-block; bottom: 12px; right: 5px;">{label}</span>
<label class="switch">
  <input type="checkbox" id="togBtn" bind:checked on:click={handleClick} {disabled} >
  <div class="slider round {disabled ? 'disabled' : ''}">
    <span class="on" style="right: 0;"> <i class="{icon}" aria-hidden="true"></i> </span>
    <span class="off"></span>
  </div>
</label>

<ModalConfirm
    bind:showModal={showModal}
    zindex="1052"
    sizeClass="modal-md"  
    targetClass="confirm-options"
    showCancel={true}
    on:confirm={Switch}
    on:close={Cancel}>
    <div slot="header">  
        <h5 class="title">
            {#if checked}
              {checkedModalHeader}
            {:else}
              {uncheckedModalHeader}
            {/if}
        </h5>
    </div>
    <div slot="content">
        {#if checked}
          {checkedModalMessage}
        {:else}
          {uncheckedModalMessage}
        {/if}
    </div>
</ModalConfirm>
